// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"141":"6ff231ce","879":"30b9773f"}[chunkId] + ".js";
};